import { Column } from "./DataTable";
import { Measure } from "../../utils/api";

export const getColumnFromMeasure = (measure: Measure): Column => {
  return { id: measure.id, name: measure.units ? `${measure.label} (${measure.units})` : measure.label };
};
